/**
 * Line icons for the sidebar, keyed by the path they lead to. They carry no meaning of their own
 * (the label always does — visibly, or as the accessible name and tooltip once the sidebar is
 * folded), so they are drawn inline rather than pulled from an icon library for eighteen glyphs.
 */
const PATHS: Readonly<Record<string, string>> = {
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-3.5-3.5',
  '/catalogo': 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  '/pedidos': 'M7 3h10a1 1 0 0 1 1 1v17l-3-2-3 2-3-2-3 2V4a1 1 0 0 1 1-1zM9 8h6M9 12h6',
  '/pagamentos': 'M3 6h18v13H3zM3 10h18M7 15h3',
  '/rastreamento':
    'M3 7h11v9H3zM14 10h4l3 3v3h-7M7 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM17 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
  '/backoffice/clientes': 'M4 21V9l8-5 8 5v12M9 21v-6h6v6M8 11h.01M12 11h.01M16 11h.01',
  '/backoffice/inatividade': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5M12 16h.01',
  '/backoffice/produtos': 'M4 8l8-4 8 4-8 4zM4 8v8l8 4 8-4V8M12 12v8',
  '/backoffice/fornecedores': 'M4 20V9l5 3V9l5 3V5h6v15zM8 16h1M12 16h1M16 16h1',
  '/backoffice/unidades': 'M3 16l13-13 5 5L8 21zM7 12l2 2M10 9l2 2M13 6l2 2',
  '/backoffice/catalogos': 'M4 5h7v6H4zM13 5h7v6h-7zM4 15h16M4 19h10',
  '/backoffice/custos': 'M12 3v18M16 7a4 3 0 0 0-8 0c0 4 8 2 8 6a4 3 0 0 1-8 0',
  '/backoffice/spreads':
    'M5 19L19 5M7 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  '/backoffice/tabelas-preco': 'M3 12V4h8l10 10-8 8zM7.5 8.5h.01',
  '/backoffice/contratos': 'M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h4',
  '/backoffice/posicao-contratual': 'M4 20h16M7 16v-5M12 16V7M17 16v-8',
  '/backoffice/titulos': 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h3',
  '/backoffice/prazos': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  '/backoffice/pedidos': 'M9 4h6v3H9zM7 5H5v16h14V5h-2M9 12l2 2 4-4',
  '/backoffice/pagamentos': 'M3 6h18v13H3zM3 10h18M7 15h3',
  '/backoffice/aprovacoes': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8 12l3 3 5-6',
  '/backoffice/fechamento-diario': 'M4 5h16v15H4zM4 9h16M8 3v4M16 3v4M8 14h3',
  '/backoffice/exportacao': 'M12 4v11M7 10l5 5 5-5M5 20h14',
  '/backoffice/entregas':
    'M3 7h11v9H3zM14 10h4l3 3v3h-7M7 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM17 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
  '/backoffice/conciliacao':
    'M12 3v18M5 7h14M5 7l-2 6a3 3 0 0 0 4 0zM19 7l-2 6a3 3 0 0 0 4 0zM8 21h8',
  '/backoffice/indicadores': 'M4 19h16M6 15l4-4 3 3 5-6',
  '/backoffice/visao-geral': 'M4 4h7v9H4zM13 4h7v5h-7zM13 11h7v9h-7zM4 15h7v5H4z',
  '/backoffice': 'M4 4h16v16H4zM4 9h16M9 9v11',
  collapse: 'M4 4h16v16H4zM9 4v16M15 10l-2 2 2 2',
  expand: 'M4 4h16v16H4zM9 4v16M13 10l2 2-2 2',
};

export function NavIcon({ name }: { readonly name: string }) {
  const d = PATHS[name] ?? PATHS['/backoffice'];
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={d} />
    </svg>
  );
}
